<template>
  <v-app>
      <v-main class="blue-grey lighten-4">
        <v-container fill-height fluid  style="max-width:1200px">
            <v-row align="center" justify="center">
                <v-col md="8" class="d-none d-md-block">
                   
                    <v-img v-if="$t('id') === 'es' " src="@/assets/es/perspective.gif" max-height="600" contain></v-img>
                    <v-img v-if="$t('id') === 'pt' " src="@/assets/pt/perspective.gif" max-height="600" contain></v-img>
                    
                </v-col>
                <v-col md="4">
                    <v-sheet class="ma-2 pa-6" color="white"  rounded elevation="12">
                        <div class="d-none mb-5" >
                            <span class="pb-2 text-h5" style="border-bottom:4px solid #1565C0">Iniciar sesión AdvE</span>
                        </div>
                        <v-row>
                            <v-col cols="6" class="text-center">
                                 <v-img class="ma-auto" src="@/assets/logoAdv.png" max-width="150"></v-img>
                            </v-col>
                            <v-col cols="6" class="text-center">
                                 <v-img class="ma-auto" src="@/assets/logo_ah.jpeg" max-width="150"></v-img>
                            </v-col>
                        </v-row>
                        <br />
                        <div class="">

                                    <div class="text-left ">
                                        <div class="form-group">
                                            <div class="black--text"><b>{{ $t("login.user") }}</b></div>
                                            <input type="text" name="user" id="user" class="form-control" :placeholder="$t('login.userPlaceholder')" v-model="loginForm.usuario">
                                        </div>
                                        <div class="form-group mt-6">
                                            
                                            <div class="black--text font-weight-bold">{{ $t("login.password") }}</div>
                                            <input @keypress.enter="loginUser()"  type="password" name="password" id="password" class="form-control" :placeholder="$t('login.passwordPlaceholder')" v-model="loginForm.contra">
                                        </div>
                                    </div>
                                    <div v-if="errorLogin" class="mt-3 error text-danger white--text text-center">{{$t(errorLogin)}}</div>
                                    <v-btn class="mt-6"  
                                        :disabled="loading"
                                        @click="loginUser()" 
                                        color="primary" width="100%">
                                        <v-progress-circular v-if="loading" indeterminate color="white" class="ma-2"></v-progress-circular>
                                        {{ $t("login.button") }}
                                    </v-btn>
                                    <div class="mt-6 text-center">
                                        <span style="cursor:pointer" @click="recovery.show = true">{{ $t("login.quest") }}</span>
                                    </div>
                                    <div class="mt-6 text-center">
                                       <LocaleSelect mode="mini" />
                                    </div>
                        </div>
                        
                    </v-sheet>
                </v-col>
            </v-row>
            <v-dialog
                v-model="recovery.show"
                max-width="500px"
                transition="dialog-transition"
            >
                <v-card>
                    <v-toolbar dense flat color="blue" class="white--text">
                        <v-toolbar-title>Info</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="mt-4">
                        {{$t('login.forgotMessage')}}
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>   
      </v-main>
  </v-app>
</template>

<script>
import loginServices from '@/services/loginServices'
import LocaleSelect from '../../components/app/util/LocaleSelect.vue';
export default {
    components: {LocaleSelect},
    data: ()=>({
        loginForm:{
            usuario: '',
            contra: ''
        },
        errorLogin: '',
        boton: 'Ingresar',
        loading:false,
        recovery:{
            message:'Contactar con el equipo de TI de su institución',
            show: false
        }

    }),
    mounted(){
        localStorage.removeItem("hope");
    },
    methods:{
        loginUser(){
            
            localStorage.removeItem("hope");
            this.loading = true;
            const user = {
                username: this.loginForm.usuario,
                password: this.loginForm.contra
            }
            user.username = user.username.replace(' ', '');
            loginServices.login(user)
            .then(response => {
                this.loading = false;
                const logeo = response.data;
                if(logeo.error){
                    this.errorLogin = logeo.mensaje || 'login.error.password';
                }else{
                    localStorage.setItem("hope", logeo.token);
                    //console.log(logeo.mensaje);
                    this.$router.push('/app')
                }
            })
            .catch(error=>{
                this.loading = false;
                if (error.response) {
                        this.errorLogin = "login.error.server_undefined"
                    } else if (error.request) {
                        this.errorLogin = "login.error.server_error"
                        setTimeout(()=>{this.errorLogin = ''}, 5000)
                        this.loading = false;
                    } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    }
            });
            //this.$router.push('/app')
        }
    }

}
</script>


<style scoped>
    .form-control{
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }.btn-primary {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }
    .w-100{
        width: 100%;
    }
    .form-control:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
    }
    .cursor-pointer{
        cursor: pointer;
    }
    .text-primary{
        font-weight: bold;
    }

</style>